/**
 * Sets a cookie in the browser.
 *
 * @param name - The name of the cookie.
 * @param value - The value to store in the cookie.
 * @param days - Optional. The number of days until the cookie expires. If omitted, the cookie will be a session cookie.
 *
 * @example
 * ```typescript
 * // To set a cookie that expires in 30 days:
 * setCookie('username', 'JohnDoe', 30);
 *
 * // To set a session cookie:
 * setCookie('sessionID', 'abc123');
 * ```
 */
export function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = ` expires=${date.toUTCString()};`;
    }
    document.cookie = `${name}=${value};${expires} path=/; SameSite=Strict; Secure`;
}
/**
 * A quick method of unsetting a cookie. setCookie can also be used with a negative value for the "days" parameter
 *
 * @param name
 */
export function unsetCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
}
/**
 * Retrieves the value of a cookie by name.
 *
 * @param name - The name of the cookie to retrieve.
 * @returns The value of the cookie if found, or an empty string if the cookie does not exist.
 *
 * @example
 * ```typescript
 * // To get the value of a cookie named 'username':
 * const username = getCookie('username');
 *
 * // To handle cases when the cookie is not found:
 * const username = getCookie('username');
 * if (username) {
 *   console.log(`Hello ${username}`);
 * } else {
 *   console.log('Cookie not found');
 * }
 * ```
 */
export function getCookie(name) {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
            return cookie.substring(cookieName.length, cookie.length);
        }
    }
    return '';
}
export function getJWTPayload() {
    const jwt = getCookie('q360_at');
    if (!jwt) {
        return;
    }
    const parts = jwt.split('.');
    if (parts.length !== 3) {
        alert('Invalid JWT: it must have 3 parts separated by dots.');
        return;
    }
    return JSON.parse(base64UrlDecode(parts[1]));
}
function base64UrlDecode(str) {
    str = str.replace('-', '+').replace('_', '/');
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
